import { useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { notifications } from "@mantine/notifications";
import {
  Button,
  Center,
  Divider,
  Group,
  Paper,
  Skeleton,
  Stack,
  Text,
} from "@mantine/core";
import AvatarEditor from "../../account/components/AvatarEditor";
import { getFieldIcon } from "../../community/util";
import AdminInput from "./adminInput/AdminInput";
import UnlockAccount from "./UnlockAccount";
import ActivateAccount from "./ActivateAccount";
import DisableAccount from "../DisableAccount";
import DeleteAccount from "../DeleteAccount";
import { IconSignRight } from "@tabler/icons-react";

const AdminPanelCenter = ({ setCurrent, profile, loading, setProfile, me }) => {
  const lang = useLanguage((s) => s.language);

  const [showAll, setShowAll] = useState(false);

  const userSettings = useMemo(() => {
    if (showAll) {
      return [
        {
          label: lang.profile.subscription,
          value: "subscriptions",
        },
        {
          label: lang.profile.last_name,
          value: "last_name",
        },
        {
          label: lang.profile.first_name,
          value: "first_name",
        },
        {
          label: lang.profile.mail,
          value: "email",
        },
        {
          label: lang.profile.password,
          value: "password",
        },
        {
          label: lang.profile.civility,
          value: "sex",
        },
        {
          label: lang.profile.phone,
          value: "phone",
        },
        {
          label: lang.profile.mobile_phone,
          value: "mobile_phone",
        },
        {
          label: lang.profile.city,
          value: "city",
        },
        {
          label: lang.profile.address,
          value: "address",
        },
        {
          label: lang.profile.postal_code,
          value: "postal_code",
        },
        {
          label: lang.profile.country,
          value: "country",
        },
        {
          label: lang.profile.language,
          value: "language",
        },
      ];
    }
    return [
      {
        label: lang.profile.subscription,
        value: "subscriptions",
      },
      {
        label: lang.profile.last_name,
        value: "last_name",
      },
      {
        label: lang.profile.first_name,
        value: "first_name",
      },
      {
        label: lang.profile.mail,
        value: "email",
      },
      {
        label: lang.profile.password,
        value: "password",
      },
      {
        label: lang.profile.mobile_phone,
        value: "mobile_phone",
      },
      {
        label: lang.profile.country,
        value: "country",
      },
      {
        label: lang.profile.language,
        value: "language",
      },
    ];
  }, [
    lang.profile.address,
    lang.profile.city,
    lang.profile.civility,
    lang.profile.country,
    lang.profile.first_name,
    lang.profile.language,
    lang.profile.last_name,
    lang.profile.mail,
    lang.profile.mobile_phone,
    lang.profile.password,
    lang.profile.phone,
    lang.profile.postal_code,
    lang.profile.subscription,
    showAll,
  ]);

  const onAccountDeleted = () => {
    setCurrent({ ...me, toDelete: profile });
  };
  const onAccountDisabled = () => {
    setCurrent((prev) => ({ ...prev, activated: false }));
  };
  const onAccountActivated = () => {
    setCurrent((prev) => ({ ...prev, activated: true }));
  };
  const onAccountUnlocked = () => {
    notifications.show({
      message: lang.settings.account_unlocked,
      color: "green.8",
    });
  };

  return (
    <Paper
      miw={300}
      component={Stack}
      gap={0}
      h={"100%"}
      p={"md"}
      py={"xs"}
      style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
    >
      <Group pb={6}>
        {loading ? (
          <Skeleton height={50} radius={"sm"} />
        ) : (
          <AvatarEditor
            profile={profile}
            isOther
            onSuccess={() => setCurrent((prev) => ({ ...prev, changed: true }))}
            withCreatedOn
          />
        )}
      </Group>
      <Divider />

      <Stack gap={0} flex={"1 1 auto"} h={0} style={{ overflow: "auto" }}>
        {profile?.source && (
          <>
          <Group wrap="nowrap" w={"100%"} gap={0} my={8}>
            <IconSignRight size={18} />

            <Stack gap={0} w={0} flex={1} ml={8}>
              <Text size="xs">Source</Text>

              <Text size="sm" fw={500}>{lang.new_ui_onboarding?.[profile?.source]}</Text>
            </Stack>
          </Group>
          
          <Divider opacity={.4} />
          </>
        )}

        {loading ? (
          <Center pos={"relative"} h={"100%"} w={"100%"}>
            <Skeleton height={"100%"} width={"100%"} />
          </Center>
        ) : (
          userSettings.map((setting) => (
            <AdminInput
              key={setting.value}
              profile={profile}
              setting={setting}
              icon={getFieldIcon(setting.value)}
              setProfile={setProfile}
            />
          ))
        )}
        <Group justify="center" mt={4} mih={50}>
          <Button
            size="xs"
            variant="subtle"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "-" : "+"} {lang.leads.infos}
          </Button>
        </Group>
      </Stack>

      <Group wrap="nowrap" pt={6}>
        <UnlockAccount profile={profile} onSuccess={onAccountUnlocked} />
        <ActivateAccount profile={profile} onSuccess={onAccountActivated} />
        <DisableAccount
          profile={profile}
          onSuccess={onAccountDisabled}
          isOther
        />
        <DeleteAccount profile={profile} onSuccess={onAccountDeleted} isOther />
      </Group>
    </Paper>
  );
};

export default AdminPanelCenter;
